import React from 'react';
import { Badge } from '../ui/badge';
import { CheckCircle, XCircle, AlertCircle, Clock } from 'lucide-react';

const StatusSummary = ({ statusCounts }) => {
  return (
    <div className="flex gap-3 flex-wrap">
      {(statusCounts.non_defini || 0) > 0 && (
        <Badge className="bg-slate-100 text-slate-600 px-3 py-1">
          <Clock className="w-3 h-3 mr-1" />
          Non défini: {statusCounts.non_defini || 0}
        </Badge>
      )}
      <Badge className="bg-emerald-100 text-emerald-700 px-3 py-1">
        <CheckCircle className="w-3 h-3 mr-1" />
        Présents: {statusCounts.present || 0}
      </Badge>
      <Badge className="bg-amber-100 text-amber-700 px-3 py-1">
        <AlertCircle className="w-3 h-3 mr-1" />
        Absences justifiées: {statusCounts.absent_justifie || 0}
      </Badge>
      <Badge className="bg-red-100 text-red-700 px-3 py-1">
        <XCircle className="w-3 h-3 mr-1" />
        Absents: {statusCounts.absent_non_justifie || 0}
      </Badge>
    </div>
  );
};

export default StatusSummary;
